import { consilioV1 } from './v1';

export const consilio = {
  versions: { v1: consilioV1 },
  current: consilioV1,
};
